import { getAppConfig } from '../../app/api/configProvider';
import axios, { Method, AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
import { ApiError } from 'types/internal/apiError';
import { msalInstance } from '@sgi/af-shell-shared';
import { getConfig } from '../../config';

export async function getAccessToken() {
  const account = msalInstance?.getActiveAccount();
  if (!account) {
    return;
  }

  const config = await getConfig();
  const authResult = await msalInstance
    .acquireTokenSilent({
      scopes: [config.REACT_APP_BFF_API_SCOPES ?? ''],
      account: account,
    })
    .catch(error => {
      // fallback to interaction when silent call fails
      return msalInstance.acquireTokenRedirect({
        scopes: [config.REACT_APP_BFF_API_SCOPES ?? ''],
        account: account,
      });
    });

  return authResult?.accessToken;
}

axios.interceptors.request.use(async (request: InternalAxiosRequestConfig) => {
  // Don't check for auth when testing
  if (process.env.NODE_ENV === 'test') {
    return request;
  }

  const token = await getAccessToken();
  if (token) {
    if (request.headers) {
      (request.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`);
    }
  }
  return request;
});

export function isApiError(error: ApiError | any): error is ApiError {
  return (error as ApiError).error !== undefined;
}

export async function apiBaseQuery<T, R = any>(url: string, method: Method, request?: R) {
  const config = await getConfig();

  const baseUrl = config.REACT_APP_BFF_API_BASEURL ?? '';
  const fullUrl = baseUrl + url;

  const response = await axios<T>({ method, url: fullUrl, data: request });
  return response.data;
}
